<div class="modal-header">
  <h4 class="modal-title">{{'Assistance' | translateOrgSpecific}}</h4>
</div>
<div class="col-md-6" style="margin-bottom: 10px;">
  <label>{{'Category' | translateOrgSpecific}}</label>
  <ejs-dropdownlist [dataSource]='actionTypeList' [(ngModel)]="actionTypeId"
    (change)="actionTypeChange($event.itemData.actionTypeId)"
    [fields]="{ text: 'actionTypeName', value: 'actionTypeId' }" [placeholder]=actionTypePlaceHolder
    [value]="actionTypeId"></ejs-dropdownlist>
</div>
<div class="col-md-11">
  <div *ngFor="let action of actionTypeOptions;  index as i" class="actions">
    <label>
      <input name="action" class="regular-radio" type="radio" [value]="action.actionId" (change)="actionChange(action, i)"
        [(ngModel)]="actionId" />
      {{action.actionName}} <br>
    </label>
    <br>
    <div *ngIf="action.isOther" style="margin-left: 10px;margin-right: 10px;">
      <input type="text" class="form-control" [(ngModel)]="othersReason" [ngModelOptions]="{standalone: true}">
      <br>
    </div>
    <div class="col-md-6" *ngIf="action.isAgencyRefered" style="margin-left: 10px;margin-right: 10px;">
      <ejs-dropdownlist [dataSource]='agencyReferredList' [(ngModel)]="agencyReferredId"
        [fields]="{ text: 'agencyName', value: 'agencyId' }" [placeholder]=actionTypePlaceHolder></ejs-dropdownlist>
      <br>
    </div>

  </div>
</div>

<div class="col-md-12 textArea">
  <label>{{'Notes' | translateOrgSpecific}}</label>
  <textarea class="form-control" rows="5" [(ngModel)]="notes"></textarea>
</div>

<div class="caseDataAlign" *ngIf="casedata">
  <label>{{casedata.caseName}}, {{casedata.participantname}} {{casedata.age}} {{casedata.gender}}</label>
</div>
<div style="text-align: right;margin-right: 15px;">
  <button class="btn btn-sm btn-apportis-tertiary btn-cancel" type="submit" (click)="onCancel()">{{ 'Cancel' |
    translateOrgSpecific }}</button>
  <button style="width:100px;" class="btn btn-sm btn-apportis-tertiary " type="submit" (click)="saveAction()"
    [disabled]="!notes || ((isOther && othersReason == null) || (isAgency && agencyReferredId == 0)) || actionTypeId == 0">{{
    'Save' | translateOrgSpecific }}</button>
</div>